module.exports = __webpack_public_path__ + "static/index/img/baikal-300.6ea14af9.jpg";